module.exports = __webpack_public_path__ + "static/img/h_bg.c79872d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/h_bg.jpg
// module id = cz08
// module chunks = 1